import { useEffect, useRef } from "react";
import intlTelInput from "intl-tel-input";
import { onTelInput } from "./onTelInput";

export const TelInput: view = ({
  onChange,
  placeholder,
  className
}) => {
  const iti = useRef<intlTelInput.Plugin | null>(null);

  const handleChange = () => {
    const value = iti.current?.getNumber();
    onChange(value);
  }
  
  useEffect(() => {
    const input = document.querySelector("#phone");
    if (input) {
      input.addEventListener('countrychange', handleChange)
      iti.current = intlTelInput(input, {
        utilsScript:
          process.env.NODE_ENV === "development"
            ? "/intl-tel-input-util.js"
            : "/recipient-dashboard/intl-tel-input-util.js",
      });
    }
    return () => {
      if (input) {
        input.removeEventListener('countrychange', handleChange)
      }
      if (iti.current) {
        iti.current.destroy();
      }
    };
  }, []);

  

  return <input className={className} onChange={handleChange} placeholder={placeholder} id="phone" type="tel" />;
};

TelInput.producers(onTelInput);
